import React, { useState } from "react";
import DetailWrapper from "../../components/detailWrapper";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import ButtonTab from "../../components/TabComponent/ButtonTab";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import OriginInputCustom from "../../components/InputComponents/originInputCustom";
import { AiOutlineArrowDown } from "react-icons/ai";
import { Button } from "semantic-ui-react";
import CommonTab from "../../components/TabComponent/CommonTab";
import TabTransfer from "./tabTransfer";
import TabWalletList from "./tabWalletList";
import { HiChevronLeft } from "react-icons/hi";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const TAB = [
  { label: "錢包列表", value: "walletList" },
  { label: "立即轉帳", value: "transfer" },
];

const PointQuery = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const navigate = useNavigate();

  const [apiCalling, setApiCalling] = useState(false);
  const [tab, setTab] = useState(TAB[0].value);
  return (
    <DetailWrapper
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1]`}
    >
      <CloseDetailPage
        hasPrev={
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          />
        }
        title={i18n("point-query")}
      />
      {/* <section className="flex items-center mb-[10px]">
        {TAB.map((item, index) => {
          return (
            <CommonTab
              key={index}
              setTab={setTab}
              tab={tab}
              label={item.label}
              value={item.value}
            />
          );
        })}
      </section> */}

      <LoadingBlock commonLoading={apiCalling}>
        <section>
          <TabTransfer activeSelect />
          {/* {tab === "walletList" ? <TabWalletList /> : <TabTransfer />} */}
        </section>
      </LoadingBlock>
    </DetailWrapper>
  );
};

export default PointQuery;
